import React, { useState, useEffect, useRef } from 'react';
import './AssetPickerPopup.css';

const AssetPickerPopup = ({ assets, onClose, onSelectAsset }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAssets, setFilteredAssets] = useState([]);
  const popupRef = useRef(null);

  // Filter assets when search query changes
  useEffect(() => {
    if (!assets) return;
    
    const filtered = assets.filter(asset => 
      asset.type === 'image' && 
      asset.fileName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredAssets(filtered);
  }, [assets, searchQuery]);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="asset-picker-overlay">
      <div className="asset-picker-popup" ref={popupRef}>
        <div className="asset-picker-header">
          <h3>Select an Image</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="asset-picker-search">
          <input
            type="text"
            placeholder="Search images..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        
        <div className="asset-picker-content">
          {filteredAssets.length === 0 ? (
            <div className="no-assets-message">
              <p>No images found</p>
            </div>
          ) : (
            <div className="asset-grid">
              {filteredAssets.map((asset, index) => {
                // Create a unique key using index and filename
                const uniqueKey = `asset-${index}-${asset.fileName.replace(/[^a-zA-Z0-9]/g, '')}`;
                
                return (
                  <div 
                    key={uniqueKey}
                    className="asset-item" 
                    onClick={() => onSelectAsset(asset)}
                  >
                    <div className="asset-preview">
                      <img 
                        src={asset.url} 
                        alt={asset.fileName}
                        key={`img-${uniqueKey}`}
                      />
                    </div>
                    <div className="asset-name" key={`name-${uniqueKey}`}>
                      {asset.fileName}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssetPickerPopup; 